import { downloadBinary } from "@/libs/file";
import { format } from "date-fns";

export function isDownloadableFile(response: Response) {
  const contentDisposition = response.headers.get("content-disposition");
  return contentDisposition?.startsWith("attachment") ?? false;
}

export type FileDownloadResponseWrapper = { status: "success" } | { status: "error"; error?: any };

export async function binaryDownloadResponseHandler<T extends Response>(
  response: T,
): Promise<FileDownloadResponseWrapper> {
  if (isDownloadableFile(response)) {
    const filename = getDownloadFilename(response);
    await downloadBinary(response, filename);
    return { status: "success" };
  }
  // explodes gracefully when faced with html django errors
  // requires backend work to cast all errors to json via drf-standardized-errors
  return response.json();
}

function getDownloadFilename(response: Response): string {
  const timestamp = format(new Date(), "yyyyMMddHHmmss");
  const rootDefault = `MineAssure-download-${timestamp}`;

  const filenameFromBackend = response.headers.get("content-disposition")?.match(/filename="(.+)"/)?.[1];
  if (filenameFromBackend) {
    return filenameFromBackend;
  }

  const contentType = response.headers.get("content-type");
  if (contentType?.includes("application/vnd.openxmlformats")) {
    return `${rootDefault}.xlsx`;
  }
  if (contentType?.includes("text/csv")) {
    return `${rootDefault}.csv`;
  }
  if (contentType?.includes("application/json")) {
    return `${rootDefault}.json`;
  }

  return rootDefault;
}
